import NewJobPricelistItemData from './NewJobPricelistItem';
import type { NewJobQuoteItem, NewJobQuoteFenceQuestions } from './models/JobInterfaces';
import type { ItemOptionList, GenericList } from './models/JobSharedInterfaces';

interface NewJobPricelistToiletProps {
    isJobEvent: boolean;
    jobTypeId: number;
    accountTypeId: number;
    customerQuoteNotesDunny: string;
    schedulePickup: boolean;
    allowAllocateToPastDate: boolean;
    jobInstalled: boolean;
    quoteItems: NewJobQuoteItem[];
    itemOptions: ItemOptionList[];
    frequencyOptions: GenericList[];
    truckHireRate: number;
    fenceQuestions: NewJobQuoteFenceQuestions;
    customerChargeFuelSurcharge: boolean;
    customerNewFuelInvoice: boolean;
    chargeFuelSurchargeSwitchedOn: boolean;
    errors: { [key: string]: string };
    addItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
    deleteItem(itemIndex: number): void;
    updateQuoteItem(quoteItem: NewJobQuoteItem, calculatePrice: boolean): void;
}


const NewJobPricelistToiletData = (props: NewJobPricelistToiletProps) => {

    const pricelistItem = <NewJobPricelistItemData isJobEvent={props.isJobEvent} jobTypeId={props.jobTypeId} schedulePickup={props.schedulePickup}
        lunchRoomExtraId={0} siteOfficeExtraId={0} showLocation={true} showExtras={true} showCleaning={false} showBracing={false} showMaintenance={true} showTruck={false} showEpaItems={false} showAdditionalHire={true}
        customerPickup={-1} allowAllocateToPastDate={props.allowAllocateToPastDate} jobInstalled={props.jobInstalled} accountTypeId={props.accountTypeId} quoteItems={props.quoteItems} itemOptions={props.itemOptions}
        truckHireRate={props.truckHireRate} fenceQuestions={props.fenceQuestions} frequencyOptions={props.frequencyOptions} extraItemOptions={[]} yesNoOptions={[]} truckOptions={[]} truckSideOptions={[]}
        chargeFuelSurchargeSwitchedOn={props.chargeFuelSurchargeSwitchedOn} customerNewFuelInvoice={props.customerNewFuelInvoice} customerChargeFuelSurcharge={props.customerChargeFuelSurcharge}
        addItem={props.addItem} deleteItem={props.deleteItem} updateQuoteItem={props.updateQuoteItem} />

    return (
        <div>
            <div className="newJobPricelist--customer-notes">{props.customerQuoteNotesDunny}</div>
                
            {pricelistItem}

            {props.errors["toiletQuoteItems"] ?
                (props.errors["toiletQuoteItems"]).split("\n").map((item: any, key: any) => {
                    return <span className="label errors" key={key}>{item}<br /></span>
                })
                : ""}

        </div>
    )

}

export default NewJobPricelistToiletData;